var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-file"},[_c('div',{staticClass:"ws-info-file__upload-btns"},_vm._l((_vm.value),function(file,fileIndex){return _c('WsStateFileItem',{key:fileIndex,staticClass:"mb-2",attrs:{"url":file,"updatable":false}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }